import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { StyleProp, ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { usePostCard } from '@/features/posts/components/feed/PostCardContext';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

const styles = StyleSheet.create({
  blocked: { fontStyle: 'italic' }
});

export const PostCardCompactBody: FC<{ style?: StyleProp<ViewStyle> }> = ({
  style
}) => {
  const { text, title, isBlocked } = usePostCard();
  const { t } = useTranslation(LocalizationNameSpace.START, {
    keyPrefix: 'components.post'
  });

  return (
    <View style={style}>
      {isBlocked ? (
        <Text
          variant="bodyLarge"
          numberOfLines={1}
          ellipsizeMode="tail"
          style={styles.blocked}
        >
          {t('blocked')}
        </Text>
      ) : (
        <Text variant="bodyLarge" numberOfLines={2} ellipsizeMode="tail">
          {title ?? text}
        </Text>
      )}
    </View>
  );
};
PostCardCompactBody.displayName = 'PostCardCompactBody';
